<template>
  <div class="d-flex justify-content-between align-items-center">
    <span>{{ row.FuelTransactionTypeName }}</span>
    <span v-if="isInputWithOrder" class="text-muted small ml-2">
      (Sipariş  Kalanı: {{ (remainingQuantity || 0).toLocaleString('tr-TR') }} lt)
    </span>

  </div>
</template>

<script>
export default {
  name: 'TransactionTypeCell',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    isInputWithOrder() {
      return this.row.FuelTransactionType === 1 && this.row.FuelStorageInputTransactionDetails?.length > 0;
    },
    remainingQuantity() {
      if (this.isInputWithOrder) {
        return this.row.FuelStorageInputTransactionDetails[0].RemainingOrderQuantity;
      }
      return 0;
    }
  }
}
</script>